import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Badge, Container, Content, InfoRow, Item, ItemLabel, Text, Title} from "./styled";
import React from "react";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";

const NOT_INCLUDED_FEATURES: { slug: string, label: string, icon: string }[] = [
    {slug: 'internal_chat', label: 'Chat interno', icon: ICONS_DROPDESK.internalChat},
    {slug: 'use_app', label: 'Aplicativo mobile (Android e iOS)', icon: ICONS_DROPDESK.mobile},
];

const NotIncludedFeatures = (
    {
        contractedExtensionSlugs
    }: {
        contractedExtensionSlugs: string[]
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    const features = NOT_INCLUDED_FEATURES.filter(feature => !contractedExtensionSlugs.includes(feature.slug));

    if (features.length === 0) {
        return null;
    }

    return (
        <Container>
            <Title size={17} color={colors.text}>Não incluso no plano:</Title>
            <Content background={colors.onBackground}>
                {features.map((feature) => (
                    <Item key={feature.slug}>
                        <ItemLabel>
                            <DropDeskIcon icon={ICONS_DROPDESK.cancel} size={12} color={colors.hintInverse}/>
                            <DropDeskIcon icon={feature.icon} size={15} color={colors.hintInverse}/>
                            <Text color={colors.text} size={15}>{feature.label}</Text>
                        </ItemLabel>
                        <Badge background={`${colors.accent}18`} color={colors.accent}>
                            <DropDeskIcon icon={ICONS_DROPDESK.extension} size={12} color={colors.accent}/>
                            Extensão
                        </Badge>
                    </Item>
                ))}
                <InfoRow>
                    <DropDeskIcon icon={ICONS_DROPDESK.info} size={13} color={colors.hintInverse}/>
                    <Text color={colors.hintInverse} size={13}>
                        Esses recursos são contratados à parte, como extensões.
                    </Text>
                </InfoRow>
            </Content>
        </Container>
    );
}
export default NotIncludedFeatures;
